"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
const stats = [{
  value: "100%",
  label: "Conformidade Fiscal"
}, {
  value: "+10",
  label: "Anos de Experiência"
}, {
  value: "Total",
  label: "Foco na Comunidade"
}];
export default function AKrbAoSeuLado() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="a-krb-ao-seu-lado" className="dark bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl shadow-black/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576722/img/accountant_shaking_hands_client_modern_office.png" alt="Contador da KRB cumprimentando um cliente em um escritório moderno" className="object-cover w-full h-full" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 bg-card/95 backdrop-blur-sm border border-border p-4 rounded-xl shadow-lg flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <ShieldCheck className="size-6" />
                </div>
                <div>
                  <p className="font-semibold text-card-foreground">Segurança Fiscal</p>
                  <p className="text-sm text-muted-foreground">Sua empresa em boas mãos na Irlanda</p>
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute -inset-4 -z-10 bg-primary/5 rounded-[2rem] blur-2xl" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <span className="inline-block text-primary font-semibold tracking-wider uppercase text-sm">
                Nossa Missão
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight">
                Mais que contabilidade, somos seus parceiros estratégicos na Irlanda.
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                Entendemos profundamente os desafios de empreender e trabalhar de forma independente em um novo país. Nossa missão é simplificar a complexa burocracia irlandesa para que você possa focar no que realmente importa: o crescimento do seu negócio.
              </p>
              <p>
                Com um atendimento dedicado à comunidade brasileira, garantimos que suas obrigações fiscais estejam sempre em dia. Evite multas, atrasos e dores de cabeça com o Revenue e o CRO contando com especialistas que falam a sua língua e entendem a sua realidade.
              </p>
            </div>

            {}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border/50">
              {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col gap-2">
                  <span className="text-3xl md:text-4xl font-bold text-primary">
                    {stat.value}
                  </span>
                  <span className="text-sm font-medium text-muted-foreground leading-tight">
                    {stat.label}
                  </span>
                </div>)}
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="text-base h-12 px-8">
                <Link to="#contato">
                  Fale com um Especialista
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}